export const messageTop = 73
// 每60分钟重新验证/更新缓存/ISR
export const updateSeconds = 3600

// 货币种类
export const currencyArr = [
  { key: 'HK$', label: 'HKD(HK$)' },
  { key: '¥', label: 'CNY(¥)' },
  { key: 'NT$', label: 'TWD(NT$)' },
  { key: 'US$', label: 'USD(US$)' },
  { key: 'CA$', label: 'CAD(CA$)' },
  { key: '€', label: 'EUR(€)' },
  { key: 'AU$', label: 'AUD(AU$)' },
  { key: 'SG$', label: 'SGD(SG$)' },
  { key: 'RM', label: 'MYR(RM)' },
  { key: 'Rp', label: 'IDR(Rp)' },
  { key: '£', label: 'GBP(£)' },
  { key: '₩', label: 'KRW(₩)' },
  { key: '円', label: 'JPY(円)' },
  { key: '฿', label: 'THB(฿)' },
  { key: 'NZ$', label: 'NZD(NZ$)' },
  { key: 'R$', label: 'BRL(R$)' }
]

// 语言种类
export const langArr = [
  { key: 'zh-CN', label: '简体' },
  { key: 'zh-HK', label: '繁體' },
  { key: 'en', label: 'English' }
]
